import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 查询版本更新
const allConfVersions = token => new Promise((resolve, reject) => {
    request({
        url: apis.conf_version_all + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
});

// 版本更新
const updateConfVersion = obj => new Promise((resolve, reject) => {
    const {
        configVersionBO,
        token
    } = obj;
    request({
        url: apis.conf_version_update + '?token=' + token,
        data: configVersionBO
    }).then(res => {
        resolve(res);
    })
});

// 推送当前版本
const pushConfVersion = token => new Promise((resolve, reject) => {
    request({
        url: apis.conf_version_push + '?token=' + token
    }).then(res => {
        resolve(res);
    })
});


export default {
    allConfVersions,
    updateConfVersion,
    pushConfVersion
}



// WEBPACK FOOTER //
// ./src/service/conf_version_api.js